module.exports = __webpack_public_path__ + "static/15-bba9aaceadff181f441cc20ceef39580.png";